import api from './api';

export const accountService = {
  async getAccounts(params = {}) {
    const cleanedParams = Object.fromEntries(
      Object.entries(params).filter(([, value]) => value !== undefined && value !== '' && value !== null)
    );
    const queryParams = new URLSearchParams(cleanedParams).toString();
    const response = await api.get(`/accounts${queryParams ? `?${queryParams}` : ''}`);
    return response.data;
  },

  async getAccountById(id) {
    const response = await api.get(`/accounts/${id}`);
    return response.data;
  },

  async createAccount(accountData) {
    const response = await api.post('/accounts', accountData);
    return response.data;
  },

  async updateAccount(id, accountData) {
    const response = await api.put(`/accounts/${id}`, accountData);
    return response.data;
  },

  async deleteAccount(id) {
    const response = await api.delete(`/accounts/${id}`);
    return response.data;
  },

  async getAdminAccounts() {
    const response = await api.get('/accounts/admin/all');
    return response.data;
  },
};